/**
 * Simply remove the no-js classname from the document body
 */
export const updateBodyClassname = () => {
	document.body.classList.remove('no-js');
};
